import type { HTMLProps } from 'react';

import { Trans } from '@lingui/react/macro';

export const Description = ({
  children,
  className = '',
  ...props
}: HTMLProps<HTMLDivElement>) => (
  <div className={'flex flex-col gap-16 ' + className} {...props}>
    <h2 className="heading-sm">
      <Trans context="integrations-guide" comment="Heading">
        Get started
      </Trans>
    </h2>
    <P>
      <Trans context="integrations-guide" comment="Paragraph 1">
        Access and manage documents from Google Drive, Dropbox, and OneDrive
        directly on your reMarkable. Link your accounts to browse files, copy
        them to My files for distraction-free work, or upload new notes.
      </Trans>
    </P>
    <P>
      <Trans context="integrations-guide" comment="Paragraph 2">
        With Send to Slack, you can convert notes and sketches using AI, then
        move them to Slack to continue your work.
      </Trans>
    </P>
    <P>
      <b>
        <Trans
          context="integrations-guide"
          comment="Paragraph 3: Data usage disclaimer bullets preamble, bolded"
        >
          We care about your data. Here&apos;s what we&apos;ll use:
        </Trans>
      </b>
    </P>
    <ul className="list-disc pl-16">
      <li>
        <Trans
          context="integrations-guide"
          comment="Data usage disclaimer bullet"
        >
          Your username, so that we can log you in
        </Trans>
      </li>
      <li>
        <Trans
          context="integrations-guide"
          comment="Data usage disclaimer bullet"
        >
          Access to your stored files so that you can either browse or download
          them
        </Trans>
      </li>
      <li>
        <Trans
          context="integrations-guide"
          comment="Data usage disclaimer bullet"
        >
          Write access, so you can upload notes
        </Trans>
      </li>
    </ul>
    {children}
  </div>
);

const P = ({
  children,
  className = '',
  ...props
}: HTMLProps<HTMLParagraphElement>) => (
  <p className={'body-md ' + className} {...props}>
    {children}
  </p>
);
